import { render, staticRenderFns } from "./Hotspot.vue?vue&type=template&id=4f23d647"
import script from "./Hotspot.vue?vue&type=script&lang=js"
export * from "./Hotspot.vue?vue&type=script&lang=js"
import style0 from "./Hotspot.vue?vue&type=style&index=0&id=4f23d647&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports